(function($) {

	var map = null
		, markers = [];

	function initializeMap() {
		map = new google.maps.Map(document.getElementById('map'), {});
	}

	function loadPositions() {
		var root = $('[data-map="marker"]', '#map')
			, positions = [];

		$.each(root, function (index, element) {
			var that = $(element);

			positions.push(new google.maps.LatLng(
				that.attr('data-latitude'),
				that.attr('data-longitude')
			));
		});

		return positions;
	}

	function drawMap() {
		var positions = loadPositions();

		if (positions.length) {
			initializeMap();

			$.each(positions, function(index, position) {
				drawMarker(position);
			});

			centerOnMarkers();
		}
	}

	function drawMarker(position) {
		markers.push(new google.maps.Marker({
			map: map,
			position: position
		}));
	}

	function centerOnMarkers() {
		map.fitBounds(markers.reduce(function(bounds, marker) {
			return bounds.extend(marker.getPosition());
		}, new google.maps.LatLngBounds()));

		/** Fix Zoom Level */
		var listener = google.maps.event.addListener(map, "idle", function() {
			if (map.getZoom() > 16)
				map.setZoom(16);
			google.maps.event.removeListener(listener);
		});
	}

	$(function () {
		drawMap();
	});

})(jQuery);